module.exports = __webpack_public_path__ + "cloud-3.svg?7e4f4d2a783f8716e4d202b4b4ff257b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-3.svg
// module id = 41
// module chunks = 0